import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import whatsapp from "../assets/images/whatsapp.svg";
import telegram from "../assets/images/telegram.svg";
import livechat from "../assets/images/baji-chat.png";
const Footer = () => {
  const location = useLocation();
  const { user, showSidebar, active, setFooterLink } = useContext(AuthContext);
  const navigate = useNavigate();
  const [casinoModel, setCasinoModel] = useState(false);
  const [startX, setStartX] = useState(null);
  const [startY, setStartY] = useState(null);
  const [icon, setIcon] = useState({});
  const handleTouchStart = (event) => {
    const touch = event.touches[0];
    setStartX(touch.clientX);
    setStartY(touch.clientY);
  };

  const getData = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { data } = await apiGet(apiPath?.getIcon, {
      website: "baji247.live"
    });
    if (data?.success) {
      setIcon(data?.results);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const handleTouchEnd = (event) => {
    const touch = event.changedTouches[0];
    const endX = touch.clientX;
    const endY = touch.clientY;
    const distance = Math.sqrt((endX - startX) ** 2 + (endY - startY) ** 2);
    if (distance < 5) {
      setCasinoModel(true);
    }
  };
  return (
    <>
      <div className="style09 " >
        {/* <nav className="cls-footer-sec sk-footer">
          <ul className="" style={{ display: "flex", justifyContent: "space-between" }}>
            <li id="sports" className="">
              <a
                neua="Sports"
                className="ui-link"
                href="https://baji24.com/m/sports/cricket"
              >
                <img
                  className="icon-sports"
                  src="/assets/images/transparent.gif"
                  alt=""
                />
                Exch
              </a>
            </li>
            <li id="inPlay" className="">
              <a neua="In-Play" className="ui-link" href="https://baji24.com/m/inplay">
                <img
                  className="icon-inplay"
                  src="/assets/images/transparent.gif"
                  alt=""
                />
                In-Play
              </a>
            </li>
            <li id="home" className="main-nav active">
              <a neua="Home" href="https://baji24.com/m/userhome">
                <img
                  className="icon-home"
                  src="/assets/images/transparent.gif"
                  alt=""
                />
                Home
              </a>
            </li>
            <li id="referral" className="main-nav">
              <a className="ui-link" href="https://baji24.com/m/referral">
                <img
                  className="icon-pin"
                  src="/assets/images/transparent.gif"
                  alt=""
                />
                Referral
              </a>
            </li>
            <li id="account" className="main-nav">
              <a className="ui-link" href="https://baji24.com/m/login">
                <img
                  className="icon-account"
                  src="/assets/images/transparent.gif"
                  alt=""
                />
                Account
              </a>
            </li>
          </ul>
        </nav> */}

        {/* {location?.pathname == "/" && !showSidebar && active == "sports" && (
          
          
          
          <div className="betbtn1">
            
              <div
              onClick={() => {
                window.open(icon?.whatsappContent?"https://wa.me/"+icon?.whatsappContent:"https://wa.me/+971556329296", "_self");
              }}
              >
                <img
                  src={icon?.whatsappIcon?import.meta.env.VITE_API_BASE_URL + icon?.whatsappIcon:whatsapp}
                  alt=""
                />
              </div>
            
              <div
                onClick={() => {
                  
                  window.open(icon?.telegramContent?"https://t.me/"+icon?.telegramContent:"https://t.me/+971556329296", "_self");
                }}>
                <img
                  src={icon?.telegramIcon?import.meta.env.VITE_API_BASE_URL + icon?.telegramIcon:telegram}
                  alt=""
                />
              </div>
            
            
              <div
                onClick={() => {
                  window.open(icon?.livechatContent, "_self");
                }}
              >
                <img
                  src={icon?.livechatIcon?import.meta.env.VITE_API_BASE_URL + icon?.livechatIcon:livechat}
                  alt=""
                />
              </div>
            
           
          
          </div>
          
          
        )} */}

      </div>
    </>
  );
};

export default Footer;
